declare global {
  interface Window {
    FB: {
      init(params: { appId: string; version: string; cookie?: boolean; xfbml?: boolean }): void;
      login(
        callback: (response: { authResponse?: { accessToken: string } | null; status: string }) => void,
        options?: { scope?: string },
      ): void;
      getLoginStatus(
        callback: (response: { authResponse?: { accessToken: string } | null; status: string }) => void,
      ): void;
    };
    fbAsyncInit?: () => void;
  }
}

let loadPromise: Promise<void> | null = null;

export function loadFacebookSDK(appId: string): Promise<void> {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    if (typeof window === "undefined") {
      reject(new Error("Facebook SDK requires a browser environment"));
      return;
    }

    if (window.FB) {
      window.FB.init({ appId, version: "v19.0", cookie: true, xfbml: false });
      resolve();
      return;
    }

    window.fbAsyncInit = () => {
      window.FB.init({ appId, version: "v19.0", cookie: true, xfbml: false });
      resolve();
    };

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("Failed to load Facebook SDK"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}

export function facebookLogin(): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!window.FB) {
      reject(new Error("Facebook SDK not loaded"));
      return;
    }

    window.FB.login(
      (response) => {
        if (response.authResponse?.accessToken) {
          resolve(response.authResponse.accessToken);
        } else {
          reject(new Error("Facebook login cancelled"));
        }
      },
      { scope: "email,public_profile" },
    );
  });
}
